/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type UpdateAuthClientRequestBody = {
  /**
   * Whether the client is enabled where typed auth client resolution is enforced.
   */
  enabled?: boolean | undefined;
  /**
   * The auth client id.
   */
  id: string;
  /**
   * The new name.
   */
  name?: string | undefined;
};

/** @internal */
export type UpdateAuthClientRequestBody$Outbound = {
  enabled?: boolean | undefined;
  id: string;
  name?: string | undefined;
};

/** @internal */
export const UpdateAuthClientRequestBody$outboundSchema: z.ZodMiniType<
  UpdateAuthClientRequestBody$Outbound,
  UpdateAuthClientRequestBody
> = z.object({
  enabled: z.optional(z.boolean()),
  id: z.string(),
  name: z.optional(z.string()),
});

export function updateAuthClientRequestBodyToJSON(
  updateAuthClientRequestBody: UpdateAuthClientRequestBody,
): string {
  return JSON.stringify(
    UpdateAuthClientRequestBody$outboundSchema.parse(
      updateAuthClientRequestBody,
    ),
  );
}
